import { SHORT_DATE_TIME_FORMAT } from '@/lib/core/constants/constants'

import { formatDateTime } from '@/lib/utils/date-time'

import { TaskDefinition } from '../../types/task'
import { findTaskSchedule } from '../../utils/taskSchedule'
import styles from './AdditionalAssignVehicleModal.module.css'
import { TaskStatusDropdown } from '../TaskStatusDropdown'

export interface AssignVehicleTaskDetailsProps {
  displayTask: TaskDefinition
  showStatus: boolean
}

export const AssignVehicleTaskDetails = ({
  displayTask,
  showStatus = false,
}: AssignVehicleTaskDetailsProps) => {
  const schedule = findTaskSchedule(displayTask)

  return (
    <div className={styles.assignedVehicleModalContentDetails}>
      <div className={styles.assignedVehicleModalContentDetailsColum}>
        <div className={styles.assignedVehicleModalContentDetailsItem}>
          <div className={styles.assignedVehicleModalContentDetailsItemLabel}>ISSUED BY</div>
          <div>{displayTask.assignedByOrg.name}</div>
        </div>
        <div className={styles.assignedVehicleModalContentDetailsItem}>
          <div className={styles.assignedVehicleModalContentDetailsItemLabel}>LOCATION TO</div>
          <div>{displayTask.taskDefinition.locations[1]?.name || 'N/A'}</div>
        </div>
        <div className={styles.assignedVehicleModalContentDetailsItem}>
          <div className={styles.assignedVehicleModalContentDetailsItemLabel}>START DATE</div>
          <div>{formatDateTime(schedule?.start, SHORT_DATE_TIME_FORMAT)}</div>
        </div>
      </div>
      <div className={styles.assignedVehicleModalContentDetailsColum}>
        <div className={styles.assignedVehicleModalContentDetailsItem}>
          <div className={styles.assignedVehicleModalContentDetailsItemLabel}>DESCRIPTION</div>
          <div>{displayTask.taskDefinition.description || 'N/A'}</div>
        </div>
        <div className={styles.assignedVehicleModalContentDetailsItem}>
          <div className={styles.assignedVehicleModalContentDetailsItemLabel}>LOCATION FROM</div>
          <div>{displayTask.taskDefinition.locations[0]?.name || 'N/A'}</div>
        </div>
        <div className={styles.assignedVehicleModalContentDetailsItem}>
          <div className={styles.assignedVehicleModalContentDetailsItemLabel}>END DATE</div>
          <div>{formatDateTime(schedule?.end, SHORT_DATE_TIME_FORMAT)}</div>
        </div>
      </div>
      <div className={styles.assignedVehicleModalContentDetailsColum}>
        {showStatus && (
          <div className={styles.assignedVehicleModalContentDetailsItem}>
            <TaskStatusDropdown
              task={displayTask as TaskDefinition}
              currentStatus={displayTask.status}
              onStatusUpdated={() => {}}
            />
          </div>
        )}
      </div>
    </div>
  )
}
